export default __webpack_public_path__ + "static/media/leftBackground2.ac9099eb.png";